module.exports = __webpack_public_path__ + "assets/img/pattern.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/pattern.svg
// module id = 1985
// module chunks = 0